<template>
  <Layout :is-loading="isLoading">
    <div class="bloco">
      <HeaderPage :form-open="formOpen" :page-titles="pageTitles" @onClick="abrirForm" />
      <div v-if="formOpen">
        <materialDisponivelForm ref="estoqueForm" :estoque="estoque" :set-loading="setLoading" :close="closeForm"
          :reload="reload" />
      </div>
      <div v-else>
        <div class="col-md-8 d-flex">
          <b-form-group id="input-group-1" label="Pesquisar Por Código" label-for="filter">
            <b-input-group>
              <b-form-input id="filter" v-model="insumoCodigo" type="text" placeholder="Código do insumo"
                @keydown.enter.prevent="
    insumoCodigo ? buscaInsumoCodigo() : listaEstoque()
    "></b-form-input>
              <b-input-group-append>
                <b-button @click="insumoCodigo ? buscaInsumoCodigo() : listaEstoque()">Buscar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <!-- {{ permissions}}
    {{ typeUser }}
    {{ $store.state.auth.currentUser.user.filiais }} -->
        <b-table :items="estoques" :fields="fieldTable" :empty-text="message" show-empty responsive>

          <template v-slot:cell(actions)="row">
            <div class="btn-group">
              <button
                v-if="!$store.state.auth.currentUser.user.filiais.some((f) => String(f._id) === String(row.item.obra.filial))"
                v-b-tooltip.hover title="Novo" type="button" class="btn btn-light" @click="openModalRequest(row.item)">
                <b-icon icon="plus" />
              </button>

              <button v-b-tooltip.hover title="Requerimentos" type="button" class="btn btn-light"
                @click="openModalRequests(row.item)">
                <b-icon icon="list-ul" />
              </button>
              <button v-if="permissions.includes(typeUser) &&
    $store.state.auth.currentUser.user.filiais.find((f) => {
      return String(f._id) === String(row.item.obra.filial)
    })
    " v-b-tooltip.hover title="Editar" type="button" class="btn btn-light" @click="edit(row.item)">
                <b-icon icon="pencil-square" />
              </button>
              <button v-if="permissions.includes(typeUser) &&
    $store.state.auth.currentUser.user.filiais.find((f) => {
      return String(f._id) === String(row.item.obra.filial)
    })
    " v-b-tooltip.hover title="Remover" type="button" class="btn btn-light" @click="openModalDelete(row.item)">
                <b-icon icon="trash" />
              </button>
            </div>
          </template>
        </b-table>
        <b-pagination v-if="rows > 10" v-model="currentPage" :per-page="10" :total-rows="rows" @input="listaEstoque" />
      </div>
    </div>

    <b-modal id="edit-modal" ref="editModal" v-model="openModalEdit" title="Editar Quantidade Disponível" size="md"
      centered hide-footer @hidden="clearEdit">
      <editarQuantidadeDisponivel :item="item" :set-loading="setLoading" :reload="reload" :close="clearEdit" />
    </b-modal>

    <b-modal id="modal-delete" ref="modalDelete" v-model="modalDeleteOpen" title="Excluir" size="md" centered
      hide-footer @hidden="clearDelete">
      <div class="d-block text-center">
        <p>{{ messageModal }}</p>
        <div class="d-flex justify-content-center">
          <b-button variant="danger" class="mr-2" :disabled="isLoading" @click="deleteItem">
            Excluir
          </b-button>
          <b-button variant="secondary" :disabled="isLoading" @click="clearDelete">
            Cancelar
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal ref="modalRequests" v-model="isOpenModalRequests" size="lg" title="Requisições de Material Disponível"
      ok-only ok-title="Fechar" @hidden="clearRequests" @ok="clearRequests">

      <b-table class="align-middle" :items="requests" :fields="fieldRequest" :empty-text="isLoading
    ? 'Carregando...'
    : 'Não há registro de materiais disponíveis.'
    " show-empty responsive>
        <template slot="cell(actions)" slot-scope="row">
          <div class="btn-group">
            <b-button v-if="permissions.includes(typeUser)
    " v-b-tooltip.hover :disabled="row.item.status !== 'pendente'" title="Aprovar" type="button" class="btn btn-light"
              @click="approval(row.item)">
              <b-icon icon="file-earmark-check" />
            </b-button>

            <b-button v-if="permissions.includes(typeUser)
    " v-b-tooltip.hover :disabled="row.item.status !== 'pendente'" title="Reprovar" type="button" class="btn btn-light"
              @click="reproval(row.item)">
              <b-icon icon="file-earmark-x" />
            </b-button>

            <b-button v-if="$store.state.auth.currentUser.user.filiais.find((f) => {
    return String(f._id) === String(row.item.obraRequerente[0].filial)
  })
    " title="Remover" type="button" class="btn btn-light" @click="openModalDelete(row.item, 'request')">
              <b-icon icon="trash" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-modal>

    <b-modal v-model="isOpenModalRequest" title="Requisição de Material" hide-footer @hidden="clearRequest">
      <b-form-group label="Selecione uma Obra" label-for="obra">
        <b-form-select id="obra" v-model="requerimentoInsumo.obraId" type="text" required>
          <b-form-select-option v-for="obra in obras" :key="obra._id" :value="obra">
            {{ obra.nome }}
          </b-form-select-option>
        </b-form-select>
      </b-form-group>

      <b-form-group label="Quantidade">
        <b-form-input v-model="requerimentoInsumo.quantidade" type="number" min="1" />
      </b-form-group>

      <div class="div-buttons">
        <b-button variant="primary" @click="clearRequest"> Cancelar </b-button>
        <b-button variant="primary" @click="newRequest"> Solicitar </b-button>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import HeaderPage from '@/src/components/register/header-page.vue'
import materialDisponivelForm from '@/src/components/forms/controleObra/materialDisponivelForm.vue'
import servicesMateriaisDisponiveis from '@/src/services/servicesMateriaisDisponiveis'
import editarQuantidadeDisponivel from '@/src/components/forms/controleObra/editarQuantidadeDisponivel.vue'
import alertMixin from '@/src/mixins/alertMixin'
import serviceObra from '@/src/services/serviceObra'

export default {
  components: {
    Layout,
    HeaderPage,
    editarQuantidadeDisponivel,
    materialDisponivelForm,
  },
  mixins: [alertMixin],
  data() {
    return {
      modalDeleteOpen: false,
      typeUser: this.$store.state.auth.currentUser.user.tipo_conta,
      permissions: ['administrador', 'engenheiro'],
      carregando: false,
      rows: 0,
      insumoCodigo: '',
      message: 'Nenhum registro encontrado.',
      messageModal: '',
      excludeRequest: false,
      isLoading: false,
      pageTitles: {
        title: 'Materiais Disponíveis',
        subtitle:
          'Materiais excedentes, disponíveis para transferência de outras obras',
      },
      formOpen: false,
      fieldTable: [
        {
          key: 'obra.nome',
          label: ' Obra',
          class: 'size-col-20',
          tdClass: 'align-middle',
        },
        {
          key: 'insumo',
          label: ' Cod. | Insumo',
          class: 'size-col-30',
          tdClass: 'align-middle',
          formatter: (value) => {
            if (
              typeof value.codigo === 'object' &&
              value.codigo.$numberDecimal
            ) {
              value.codigo = value.codigo.$numberDecimal
            }
            if (value.descricao_pai) {
              return `${value.codigo} | ${value.descricao_pai} - ${value.descricao
                }`
            } else {
              return `${value.codigo} | ${value.descricao}`
            }
          },
        },
        {
          key: 'quantidade',
          label: 'Quantidade',
          class: 'size-col-10',
          tdClass: 'align-middle',
          formatter: (value) => {
            return value.toLocaleString('pt-BR')
          },
        },
        {
          key: 'insumo.unidade',
          label: 'Unid.',
          class: 'size-col-10',
          tdClass: 'align-middle',
        },
        {
          key: 'actions',
          label: 'Ações',
          class: 'size-col-20',
          tdClass: 'align-middle',
        },
      ],
      isUpdating: false,
      estoque: { insumo: {} },
      estoques: [],
      units: [],
      currentPage: 1,
      openModalEdit: false,
      isOpenModalRequests: false,
      isOpenModalRequest: false,
      item: {},
      requests: [],
      messageRequestEmpty: 'Carregando',
      fieldRequest: [
        {
          key: 'obraRequerente[0].nome',
          label: 'Obra',
          class: 'size-col-20',
          thClass: 'align-middle',
          tdClass: 'align-middle',
        },
        {
          key: 'userRequest[0].nome',
          label: 'Usuário Requerente',
          class: 'size-col-20',
          thClass: 'align-middle',
          tdClass: 'align-middle',
        },
        {
          key: 'quantidade',
          label: 'Quantidade requerida',
          class: 'size-col-20',
          thClass: 'align-middle',
          tdClass: 'align-middle',
        },
        {
          key: 'status',
          label: 'Status',
          class: 'size-col-10',
          thClass: 'align-middle',
          tdClass: 'align-middle',
        },
        // {
        //   key: 'requisicao',
        //   label: 'Requisição nº',
        //   class: 'size-col-10',
        //   thClass: 'align-middle',
        //   tdClass: 'align-middle',
        // },
        {
          key: 'actions',
          label: 'Ações',
          class: 'size-col-20',
          thClass: 'align-middle',
          tdClass: 'align-middle',
        },
      ],
      requerimentoInsumo: {
        id: undefined,
        quantidade: 0,
        insumoExcedente: undefined,
      },
      obras: [],
      itemDelete: {},
    }
  },
  async created() {
    this.estoques = []
    this.estoque = {}
    this.currentPage = 1
    this.listaEstoque()
  },
  methods: {
    async openModalRequest(item) {
      this.requerimentoInsumo.insumoExcedente = item._id
      await this.listaObra()

      this.isOpenModalRequest = true
    },

    async listaObra() {
      this.setLoading(true)
      try {
        let {
          data: { data },
        } = await serviceObra.list()
        this.obras = data

        this.setLoading(false)
      } catch (error) {
        this.setLoading(false)
        this.errorMessage('Erro ao Buscar Obras')
      }
    },

    clearRequest() {
      this.isOpenModalRequest = false
      this.requerimentoInsumo.obraId = undefined
      this.requerimentoInsumo.quantidade = 0
      this.requerimentoInsumo.insumoExcedente = undefined
    },

    async newRequest() {
      const item = {
        obraRequerente: this.requerimentoInsumo.obraId
          ? this.requerimentoInsumo.obraId._id
          : undefined,
        quantidade: this.requerimentoInsumo.quantidade
          ? this.requerimentoInsumo.quantidade
          : undefined,
        insumoExcedente: this.requerimentoInsumo.insumoExcedente
          ? this.requerimentoInsumo.insumoExcedente
          : undefined,
      }

      if (!item.obraRequerente) {
        this.errorMessage('Selecione uma obra.')
        return
      }

      if (!Number(item.quantidade)) {
        this.errorMessage('Quantidade deve ser maior que 0 (zero).')
        return
      }

      try {
        this.isLoading = true
        await servicesMateriaisDisponiveis.newRequest(item)

        this.successMessage('Requisição registrada com sucesso')
        this.clearRequest()
        this.listaEstoque()
      } catch (error) {
        this.errorMessage(error.response.data.error.message)
      } finally {
        this.isLoading = false
      }
    },

    async approval(item) {
      try {
        this.isLoading = true
        await servicesMateriaisDisponiveis.approval(item._id)
        await this.getById(this.item)
        this.successMessage(
          'Aprovado com sucesso. Material retornado para estoque disponível, para viabilizar conclusão de entrega.'
        )
      } catch (error) {
        this.errorMessage(error.response.data.error.message)
      } finally {
        this.isLoading = false
      }
    },

    async reproval(item) {
      try {
        this.isLoading = true
        await servicesMateriaisDisponiveis.reproval(item._id)
        await this.getById(this.item)
        await this.listaEstoque()
        this.successMessage('Reprovado com sucesso')
      } catch (error) {
        this.errorMessage(error.response.data.error.message)
      } finally {
        this.isLoading = false
      }
    },

    async openModalRequests(item) {
      this.item = item
      await this.getById(item)
      this.isOpenModalRequests = true
    },

    clearRequests() {
      this.item = {}
      this.isOpenModalRequests = false
    },

    async getById(item) {
      try {
        this.messageRequestEmpty = 'Carregando...'
        this.isLoading = true
        const data = await servicesMateriaisDisponiveis.getById(item._id)
        this.messageRequestEmpty = 'Não há requisições para este material.'
        this.requests = data
      } catch (error) {
        this.messageRequestEmpty = 'Ocorreu um erro ao buscar requisições.'
        this.errorMessage(error.response.data.error.message)
      } finally {
        this.isLoading = false
      }
    },

    openModalDelete(item, isRequest) {
      this.itemDelete = {}
      this.itemDelete = item
      if (isRequest) {
        this.modalDeleteOpen = true
        this.messageModal = 'Tem certeza que deseja excluir a requisição?'
        this.excludeRequest = true
      } else {
        this.modalDeleteOpen = true
        this.messageModal = 'Tem certeza que deseja excluir?'
        this.excludeRequest = false
      }
    },

    async deleteItem() {
      if (this.excludeRequest) {
        try {
          this.isLoading = true
          await servicesMateriaisDisponiveis.deleteRequest(this.itemDelete._id)

          this.modalDeleteOpen = false
          this.currentPage = 1
          this.estoques = []
          this.estoque = {}
          this.listaEstoque()
          this.successMessage('Deletado com sucesso')

          this.itemDelete = {}
          await this.getById(this.item)
        } catch (error) {
          this.errorMessage(error.response.data.error.message)
        } finally {
          this.isLoading = false
        }
      } else {
        try {
          this.isLoading = true
          await servicesMateriaisDisponiveis.apaga(this.itemDelete._id)

          this.item = {}
          this.modalDeleteOpen = false
          this.currentPage = 1
          this.estoques = []
          this.estoque = {}
          this.listaEstoque()
          this.successMessage('Deletado com sucesso')
          this.itemDelete = {}
          this.item = {}
        } catch (error) {
          this.errorMessage(error.response.data.error.message)
        } finally {
          this.isLoading = false
        }
      }
    },

    clearDelete() {
      this.item = {}
      this.modalDeleteOpen = false
    },

    clearEdit() {
      this.item = {}
      this.openModalEdit = false
    },
    edit(item) {
      console.log(item)
      this.item = item
      this.openModalEdit = true
    },
    reload() {
      this.currentPage = 1
      this.estoques = []
      this.estoque = {}
      this.listaEstoque()
    },
    closeForm() {
      this.formOpen = false
    },
    showModalTransfers(item) {
      this.$bvModal.show('modal-transfers', item)
    },
    updateByFiliais() {
      this.listaEstoque()
      if (this.formOpen) {
        this.$refs.estoqueForm.listaObra()
      }
    },
    setLoading(loading) {
      this.isLoading = loading
    },
    abrirForm() {
      this.formOpen = !this.formOpen
      this.estoque = {}
      this.isUpdating = false
      if (!this.formOpen) {
        this.currentPage = 1
        this.estoques = []
        this.estoque = {}
        this.listaEstoque()
      }
    },
    async listaEstoque() {
      this.message = 'Carregando...'
      this.isLoading = true

      await servicesMateriaisDisponiveis
        .load({
          page: this.currentPage,
        })
        .then((res) => {
          const data = res

          this.estoques = data.results
          this.rows = data.count
        })
        .catch((error) => {
          console.log(error)
          this.errorMessage(
            `Erro ao listar o estoque: ${error.response.data.error.message}`
          )
        })
        .finally(() => {
          this.message = 'Nenhum registro de material disponível encontrado.'
          this.isLoading = false
        })
    },
    async buscaInsumoCodigo() {
      this.message = 'Carregando...'
      this.estoques = []
      try {
        this.isLoading = true
        let data = await servicesMateriaisDisponiveis.load({
          page: this.currentPage,
          codigoInsumo: this.insumoCodigo,
        })

        if (!data.results.length) {
          this.message =
            'Nenhum material disponível foi encontrado para essa pesquisa.'
          this.isLoading = false
          return
        }
        this.estoques = data.results
        this.rows = Number(data.count)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.message = 'Ocorreu um erro ao buscar o material disponível.'
        this.errorMessage(
          error.response.data.message !== undefined
            ? error.response.data.message
            : 'Não foi possível buscar o material disponível.'
        )
      }
    },
  },
}
</script>

<style src="../style.scss" lang="scss">
.div-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
